

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {StoreSplitAccountReportDto, StoreSplitAccountReportFeeChangeHistoryDto} from "@/api/appService";
import api from "@/api";
import moment from "moment";

@Component({
  name: "StoreSplitAccountDetail",
})
export default class StoreSplitAccountDetail extends Vue {


  @Prop({type: Object, required: true})
  dto!: StoreSplitAccountReportDto;


  @Prop({type: Boolean, required: true})
  show!: boolean;

  internalShow = false;

  isFeeEdit = false;

  feeForm = {
    fee1: 0,
    fee2: 0,
    fee3: 0,
    remark:''
  }
  feeFormRules={
    fee1: [
      { required: true, message: '请输入固定费用1', trigger: 'blur' },
      { type: 'number', message: '请输入数字值', trigger: 'blur' }
    ],
    fee2: [
      { required: true, message: '请输入固定费用2', trigger: 'blur' },
      { type: 'number', message: '请输入数字值', trigger: 'blur' }
    ],
    fee3: [
      { required: true, message: '请输入固定费用3', trigger: 'blur' },
      { type: 'number', message: '请输入数字值', trigger: 'blur' }
    ],
    remark: [
    ]
  }

  submitting = false;

  feeChangeLogs:StoreSplitAccountReportFeeChangeHistoryDto[]  = [];

  @Watch('show')
  handleShowChange(val: boolean) {
    console.log('handleShowChange', val);
    this.internalShow = val;
  }

  @Watch('dto')
  handleDtoChange(){
    this.updateFeeFormValue();
    this.fetchFeeChangeLogs();
  }


  created(){
    this.internalShow = this.show;
    this.updateFeeFormValue();
    this.fetchFeeChangeLogs();
  }

  updateFeeFormValue(){
    this.feeForm.fee1 = this.dto.fee1!;
    this.feeForm.fee2 = this.dto.fee2!;
    this.feeForm.fee3 = this.dto.fee3!;
    this.feeForm.remark = this.dto.remark??'';
  }


  @Watch('internalShow')
  handleInternalShowChange(val: boolean) {
    this.$emit('update:show', val);
  }


  handleClose(done:any){
    this.$emit('update:show', false);
    done();
  }

  handleChangeFee(){
    this.isFeeEdit = true;
  }

  handleSubmitFeeForm(){
    (this.$refs.feeForm as any).validate((valid:boolean) => {
      if(valid){
        this.doUpdateForm();
      }
    })



  }

  doUpdateForm(){

    this.submitting = true;
    api.storeSplitAccountReport.update({body:{
        id: this.dto.id!,
        ...this.feeForm
      }}).then((res:any)=>{
      this.submitting = false;
      this.$message.success('修改成功');
      this.isFeeEdit = false;
      if(res){
        const newDto = res as StoreSplitAccountReportDto;
        this.dto.fee1 = newDto.fee1;
        this.dto.fee2 = newDto.fee2;
        this.dto.fee3 = newDto.fee3;
        this.dto.splitAmountToStore = newDto.splitAmountToStore;
        this.dto.splitAmountToPartialArea = newDto.splitAmountToPartialArea;
        this.dto.splitAmountToHeadquarters = newDto.splitAmountToHeadquarters;
        this.dto.remark = newDto.remark;

        this.fetchFeeChangeLogs();
      }
    }).catch((err:any)=>{
      this.submitting = false;
    });
  }

  fetchFeeChangeLogs(){
    this.feeChangeLogs = [];
    if(this.dto.id){
      api.storeSplitAccountReport.getFeeChangeLogs({id:this.dto.id!}).then(res=>{
        this.feeChangeLogs = res??[];
      })
    }

  }

  formatTimestamp(timestamp:number | string | Date) {
    return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
  }


}

